import {Injectable} from '@angular/core';
import {CookieService} from "ngx-cookie-service";

@Injectable({
  providedIn: 'root'
})
export class CcCookieService {

  constructor(private cookieService: CookieService) {
  }

  get(name: string): string {
    return this.cookieService.get(name);
  }

  getAll(): { [key: string]: string } {
    return this.cookieService.getAll();
  }

  delete(name: string, path: string = '/', domain?: string) {
    this.cookieService.delete(name, path, domain);
  }

  deleteAll(path: string = '/', domain?: string) {
    this.cookieService.deleteAll(path, domain);
  }
}
